import { commonAuthDeleteCookies } from "../common/auth/utils";
import { signOut, setPersistence, inMemoryPersistence } from "firebase/auth";
import { logoutAPI } from "../common/services";
import { getCookie } from "../utils";
import { loginModeCookie } from "./cookies";

export async function coreLogout(redirectTo) {

    const { getFirebaseInstance } = await import("../common/firebase");
    const firebase = getFirebaseInstance();
    const logInMode = getCookie(loginModeCookie);

    try {
        const logoutRes = await logoutAPI()

        if (logInMode === "google") {
            // Set persistence to in-memory before signing out to prevent auto re-login
            await setPersistence(firebase.auth, inMemoryPersistence);
            await signOut(firebase.auth);
        }

        commonAuthDeleteCookies()

        // if in case needed to clear localstorage
        // localStorage.clear();

        if (!logoutRes?.data?.status) {
            throw new Error("Logout API failed");
        }

        if (redirectTo) {
            window.location.href = redirectTo;
        }

        return true

    } catch (error) {
        console.log("Error during logout", error);
        return false
    }
}